import i18next from 'i18next';

const columns = stats => {
  if (stats && Object.keys(stats).length) {
    const resultantColumns = stats.statsTableHeadersAndDescription.map(
      ({ property }) => {
        return {
          Header: i18next.t(`${property}Abv`),
          accessor: property,
          tooltip: i18next.t(property),
        };
      }
    );
    return [
      { Header: i18next.t('players'), accessor: 'playerName' },
      ...resultantColumns,
    ];
  }

  return [];
};

export { columns };
